import React from 'react';
import '../css/conectaTuViaje.scss';
import conexion from '../assets/images/conexion.jpg';
import estrellablanca from '../assets/images/estrellablanca.png';
import Breadcrumbs from './Breadcrumbs';
import Footer from './Footer';

export default function ConectaTuViaje() {
  const ventajas = [
    {
      title: 'Horarios',
      description: 'Opciones de horarios ',
      icon: 'schedule'
    },
    {
      title: 'Todo en uno',
      description: 'Reserva integrada',
      icon: 'local_activity'
    },
    {
      title: 'Asistencia',
      description: 'Soporte en línea',
      icon: 'support_agent'
    }
  ];

  const conexiones = [
    {
      ciudad: 'Conexiones desde La Paz',
      descripcion:
        'Destinos frecuentes: Los Cabos, Loreto, Santa Rosalía y Guerrero Negro con Transportes Águila.'
    },
    {
      ciudad: 'Conexiones desde Mazatlán',
      descripcion:
        'Destinos frecuentes: Culiacán, Guadalajara, Ciudad de México y frontera norte con Élite.'
    }
  ];

  return (
    <>
    <section className="conecta-viaje">
        
                {/* HERO */}
                <div className='conecta-hero'>

                    <div className='overlay'></div>

                    <div className='container hero-content'>

                        <div style={{ marginTop: '4rem' }}>
                            <Breadcrumbs />
                        </div>

                        <h1>Documentación para viajar</h1>

                        <p>
                            Conoce los requisitos y documentos necesarios
                            para abordar tu viaje de manera rápida y segura.
                        </p>

                    </div>

                </div>

      <div className="container">

        {/* HERO */}
        <div className="conecta-grid">

          <div className="conecta-content">
            <div className="conecta-tag">            
              <p>CONECTA TU VIAJE</p>
            </div>

            <h2>Continúa tu camino con facilidad</h2>

            <p className="description">
              Conecta tu llegada con tu siguiente trayecto. Ahora, al llegar con
              <strong> Baja Ferries</strong>, es más fácil continuar tu viaje.
              Ponemos a tu alcance opciones de traslado terrestre con aliados
              como <strong>Élite</strong> y <strong>Águila</strong>, para que
              elijas la ruta que mejor se adapte a tu destino.
            </p>

            <div className="conecta-actions">
              <a
                href="https://bajaferries.estrellablanca.com.mx/ferries"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary" >
                Ver opciones de traslado
              </a>

          
            </div>

            <div className="trust-grid">
              {ventajas.map((item, index) => (
                <div className="trust-item" key={index}>
                  <span className="material-symbols-outlined">
                    {item.icon}
                  </span>

                  <div>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bento */}
          <div className="bento-grid">
            <div className="bento-main">
              <img
                src={estrellablanca}
                alt="Conexiones terrestres Baja Ferries"
              />
            </div>

            <div className="bento-card">
              <span className="material-symbols-outlined">
                directions_bus
              </span>

              <h4>Élite</h4>

              <p>
                Confort de primera clase hacia el norte del país.
              </p>
            </div>

            <div className="bento-card">
              <span className="material-symbols-outlined">
                airport_shuttle
              </span>

              <h4>Águila</h4>

              <p>
                Líder regional conectando toda la península.
              </p>
            </div>
          </div>
        </div>

        {/* CONEXIONES */}
        <div className="conexiones-box">
          <div className="conexiones-content">

            <h3>¿Hacia dónde vas hoy?</h3>

            <p>
              Nuestras terminales de llegada están estratégicamente
              ubicadas para que tu transferencia al autobús sea en
              minutos.
            </p>

            {conexiones.map((item, index) => (
              <div
                key={index}
                open={index === 0}
                className="conexion-item"
              >
                <label><i class="fi fi-rs-arrow-circle-right"></i> {item.ciudad}</label>

                <p>{item.descripcion}</p>
              </div>
            ))}
          </div>

          <div className="conexiones-map">
            <img
              src={conexion}
              alt="Mapa de conexiones"
            />

            <div className="map-badge">
              <span className="dot"></span>
              Conecta tu viaje
            </div>
          </div>
        </div>

      </div>
    </section>

    <Footer />
    </>
  );
}